import type {
    ChangePassword,
    FirstAccess,
    ForgotPassword,
    GetEntraOptions,
    GetMe,
    Login,
    Logout,
    RedeemEntraTicket,
    ResetPassword,
    ValidateResetToken
} from '@/domain/use-cases/auth.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';

export class AuthController extends BaseControllerImpl {
    constructor(
        private readonly loginUseCase: Login,
        private readonly logoutUseCase: Logout,
        private readonly getMeUseCase: GetMe,
        private readonly forgotPasswordUseCase: ForgotPassword,
        private readonly resetPasswordUseCase: ResetPassword,
        private readonly validateResetTokenUseCase: ValidateResetToken,
        private readonly firstAccessUseCase: FirstAccess,
        private readonly changePasswordUseCase: ChangePassword,
        private readonly getEntraOptionsUseCase: GetEntraOptions,
        private readonly redeemEntraTicketUseCase: RedeemEntraTicket
    ) {
        super();
    }

    public async login(email: string, password: string) {
        return this.loginUseCase.execute({ email, password });
    }

    public async logout() {
        return this.logoutUseCase.execute();
    }

    public async getMe() {
        return this.getMeUseCase.execute();
    }

    public async forgotPassword(email: string) {
        return this.forgotPasswordUseCase.execute({ email });
    }

    public async resetPassword(token: string, newPassword: string) {
        return this.resetPasswordUseCase.execute({ token, newPassword });
    }

    public async validateResetToken(token: string) {
        return this.validateResetTokenUseCase.execute({ token });
    }

    public async firstAccess(token: string, newPassword: string) {
        return this.firstAccessUseCase.execute({ token, newPassword });
    }

    public async changePassword(currentPassword: string, newPassword: string, confirmPassword: string) {
        return this.changePasswordUseCase.execute({ currentPassword, newPassword, confirmPassword });
    }

    public async getEntraOptions() {
        return this.getEntraOptionsUseCase.execute();
    }

    public async redeemEntraTicket(ticket: string) {
        return this.redeemEntraTicketUseCase.execute(ticket);
    }
}
